import {
  getPinnedMoments,
  upsertPinnedMoments
} from '../services/pinnedMoments.service.api'

export const PINNED_MOMENTS_LOCALSTORAGE_KEY = `pinnedMomentIds`

export const getPinnedMomentIds = () => {
  const pinnedMomentIds = JSON.parse(
    localStorage.getItem(PINNED_MOMENTS_LOCALSTORAGE_KEY) || '[]'
  )

  return pinnedMomentIds
}

export const getAndSyncPinnedMomentIds = async () => {
  const nftIds = await getPinnedMoments()

  if (nftIds?.length) {
    localStorage.setItem(
      PINNED_MOMENTS_LOCALSTORAGE_KEY,
      JSON.stringify(nftIds)
    )

    return Array.from(new Set([...nftIds]).values())
  }

  localStorage.setItem(PINNED_MOMENTS_LOCALSTORAGE_KEY, JSON.stringify([]))

  return []
}

export const togglePinnedMomentId = async (id: string): Promise<string[]> => {
  const storedIds = await getPinnedMoments()

  const index = storedIds.indexOf(id)
  if (index === -1) {
    storedIds.push(id)
  } else {
    storedIds.splice(index, 1)
  }

  upsertPinnedMoments(storedIds)

  localStorage.setItem(
    PINNED_MOMENTS_LOCALSTORAGE_KEY,
    JSON.stringify(storedIds)
  )
  return storedIds
}
